import React, { useEffect } from "react";
import GridItem from "../../../../Components/UiComponents/GridItem/GridItem";
import { GridStack } from "gridstack";
import DMSHeader from "../../DMSHeader/DMSHeader";
import MISGlofReportTable from "./MISGlofReportTable";
import "../ReportEnhanced.css";

const MISDistGlofReport = () => {
  useEffect(() => {
    GridStack.init();
  }, []);

  const layoutData = [
    {
      x: 0,
      y: 0,
      width: 12,
      height: 1,
      id: 1,
      component: (
        <DMSHeader
          title="MIS GLOF Report"
          fileName="MISReportStatus.csv"
          showdownload={false}
          increaseHeaderHeight={true}
        />
      ),
      haveOverflowVisible: true,
    },
    {
      x: 0,
      y: 1,
      width: 12,
      height: 12,
      id: 2,
      component: <MISGlofReportTable />,
    },
  ];

  return (
    <div className="report-enhanced-wrapper">
      <div className="grid-stack grid-stack-instance-1 smartpole__header--transition">
        <GridItem layoutData={layoutData} />
      </div>
    </div>
  );
};

export default MISDistGlofReport;
